import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-59029df6")

_pushScopeId("data-v-59029df6")
const _hoisted_1 = { class: "flex flex-row justify-between p-4" }
const _hoisted_2 = { class: "flex flex-row items-start justify-start gap-x-5" }
const _hoisted_3 = {
  class: "flex flex-col items-end justify-end gap-x-2",
  "data-testid": "cargo-search-flight-departure"
}
const _hoisted_4 = { class: "text-2xl font-bold flight-main-text-color" }
const _hoisted_5 = { class: "text-xs font-semibold flight-main-text-color" }
const _hoisted_6 = {
  class: "flex flex-col items-center justify-center gap-y-1.5",
  style: {"min-width":"407px"},
  "data-testid": "cargo-search-flight-route"
}
const _hoisted_7 = { class: "flex flex-row items-center justify-between w-full flight-main-text-color" }
const _hoisted_8 = { class: "text-xs" }
const _hoisted_9 = {
  class: "flight-sub-text-color",
  "data-testid": "cargo-search-flight-transit-label"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row items-center w-full" }, [
  /*#__PURE__*/_createVNode("div", {
    class: "flight-line-main",
    style: {"height":"2px","width":"40px"}
  }),
  /*#__PURE__*/_createVNode("div", {
    class: "flight-line-default w-full",
    style: {"height":"2px"}
  }),
  /*#__PURE__*/_createVNode("div", {
    class: "flight-line-main",
    style: {"height":"2px","width":"40px"}
  })
], -1)
const _hoisted_11 = { class: "flex flex-row items-center justify-between w-full flight-main-text-color" }
const _hoisted_12 = { class: "text-xs font-semibold flight-main-text-color" }
const _hoisted_13 = { class: "text-xs font-semibold flight-main-text-color flex flex-row items-center gap-x-1" }
const _hoisted_14 = { class: "whitespace-nowrap" }
const _hoisted_15 = { class: "text-xs font-semibold flight-main-text-color" }
const _hoisted_16 = {
  class: "flex flex-col items-start justify-start gap-x-2",
  "data-testid": "cargo-search-flight-arrival"
}
const _hoisted_17 = { class: "text-2xl font-bold flight-main-text-color relative" }
const _hoisted_18 = {
  key: 0,
  class: "absolute top-0 right-0 text-xs flight-diff-text-color font-bold",
  style: {"transform":"translate(105%, -25%)"},
  "data-testid": "cargo-search-flight-arrival-day-diff"
}
const _hoisted_19 = { class: "text-sm font-normal flight-sub-text-color" }
const _hoisted_20 = { class: "flex flex-col items-end justify-center" }
const _hoisted_21 = {
  key: 0,
  class: "info-error",
  "data-testid": "cargo-search-flight-dimension-unavailable"
}
const _hoisted_22 = {
  key: 1,
  class: "info-error",
  "data-testid": "cargo-search-flight-dimension-unavailable"
}
const _hoisted_23 = {
  key: 2,
  class: "info-error",
  "data-testid": "cargo-search-flight-capacity-unavailable"
}
const _hoisted_24 = {
  key: 3,
  class: "info-error",
  "data-testid": "cargo-search-flight-embargo"
}
const _hoisted_25 = {
  key: 4,
  class: "info-error",
  "data-testid": "cargo-search-flight-dg-not-allowed"
}
const _hoisted_26 = {
  key: 5,
  class: "info-warning",
  "data-testid": "cargo-search-flight-delayed"
}
const _hoisted_27 = {
  key: 6,
  class: "info-success",
  "data-testid": "cargo-search-flight-on-time"
}
const _hoisted_28 = {
  key: 7,
  class: "text-sm text-black-lp-100",
  "data-testid": "cargo-search-flight-available-capacity"
}
const _hoisted_29 = { key: 0 }
const _hoisted_30 = /*#__PURE__*/_createVNode("span", null, /*#__PURE__*/_toDisplayString(" "), -1)
const _hoisted_31 = { class: "font-bold" }
const _hoisted_32 = {
  class: "border-t flight-border-color py-2 px-4 flex justify-between",
  "data-testid": "cargo-search-flight-footer"
}
const _hoisted_33 = {
  class: "flex items-center gap-x-2",
  "data-testid": "cargo-search-flight-departs-in"
}
const _hoisted_34 = { class: "text-xs font-normal text-gray-lp-800" }
const _hoisted_35 = { class: "text-xs font-bold flight-main-text-color" }
const _hoisted_36 = { class: "flex flex-row items-center gap-2" }
const _hoisted_37 = { class: "text-sm font-semibold" }
const _hoisted_38 = {
  key: 0,
  class: "w-full bg-gray-lp-2800 p-2 flex flex-row items-center justify-center gap-1",
  "data-testid": "cargo-search-flight-transit-list"
}
const _hoisted_39 = {
  key: 0,
  class: "text-xs flight-sub-text-color whitespace-nowrap"
}
const _hoisted_40 = {
  key: 1,
  class: "text-xs flight-sub-text-color whitespace-nowrap"
}
const _hoisted_41 = { class: "text-xs flight-main-text-color flex flex-row items-center gap-x-1" }
const _hoisted_42 = /*#__PURE__*/_createVNode("div", {
  class: "bg-gray-lp-1300",
  style: {"width":"1px","height":"12px"}
}, null, -1)
const _hoisted_43 = { class: "text-xs text-gray-lp-800 flex flex-row items-center gap-x-2.5" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = {
  class: "text-sm flight-main-text-color",
  style: {"font-weight":"900"}
}
const _hoisted_46 = { class: "w-full flex-col justify-center items-center" }
const _hoisted_47 = { class: "w-full flex flex-row items-center gap-x-1" }
const _hoisted_48 = /*#__PURE__*/_createVNode("div", {
  class: "bg-gray-lp-1300 w-full",
  style: {"height":"1px"}
}, null, -1)
const _hoisted_49 = { class: "text-sm font-bold flight-main-text-color flex flex-row items-center gap-x-1 flex-shrink-0" }
const _hoisted_50 = { class: "whitespace-nowrap" }
const _hoisted_51 = {
  class: "bg-gray-lp-1300 text-gray-lp-1300 w-full relative",
  style: {"height":"1px"}
}
const _hoisted_52 = { class: "w-full text-xs text-center flight-main-text-color" }
const _hoisted_53 = {
  key: 0,
  class: "px-2 flex flex-col justify-center items-center"
}
const _hoisted_54 = { class: "text-xs flight-sub-text-color whitespace-nowrap" }
const _hoisted_55 = { class: "text-xs flight-main-text-color flex flex-row items-center gap-x-1" }
const _hoisted_56 = { class: "text-xs text-gray-lp-800 flex flex-row items-center gap-x-1" }
const _hoisted_57 = {
  class: "text-sm flight-main-text-color",
  style: {"font-weight":"900"}
}
const _hoisted_58 = {
  key: 1,
  class: "w-full flex flex-col",
  "data-testid": "cargo-search-flight-transit-grid"
}
const _hoisted_59 = {
  key: 1,
  class: "px-2 flex flex-col justify-center items-center",
  style: {"width":"max-content"}
}
const _hoisted_60 = { class: "text-xs flight-sub-text-color whitespace-nowrap" }
const _hoisted_61 = { class: "text-xs flight-main-text-color flex flex-row items-center gap-x-1" }
const _hoisted_62 = { class: "text-xs text-gray-lp-800" }
const _hoisted_63 = {
  class: "text-sm flight-main-text-color",
  style: {"font-weight":"900"}
}
const _hoisted_64 = { class: "flex flex-col justify-center items-center px-2 flex-shrink-0" }
const _hoisted_65 = {
  key: 0,
  class: "text-xs flight-sub-text-color whitespace-nowrap"
}
const _hoisted_66 = {
  key: 1,
  class: "text-xs flight-sub-text-color whitespace-nowrap"
}
const _hoisted_67 = { class: "text-xs flight-main-text-color flex flex-row items-center gap-x-1" }
const _hoisted_68 = /*#__PURE__*/_createVNode("div", {
  class: "bg-gray-lp-1300",
  style: {"width":"1px","height":"12px"}
}, null, -1)
const _hoisted_69 = { class: "text-xs text-gray-lp-800 flex flex-row items-center gap-x-2.5" }
const _hoisted_70 = { key: 0 }
const _hoisted_71 = {
  class: "text-sm flight-main-text-color",
  style: {"font-weight":"900"}
}
const _hoisted_72 = { class: "flex-1 flex flex-col justify-center items-center min-w-0" }
const _hoisted_73 = { class: "w-full flex flex-row items-center gap-x-1" }
const _hoisted_74 = /*#__PURE__*/_createVNode("div", {
  class: "bg-gray-lp-1300 flex-1",
  style: {"height":"1px"}
}, null, -1)
const _hoisted_75 = { class: "text-sm font-bold flight-main-text-color flex flex-row items-center gap-x-1 flex-shrink-0" }
const _hoisted_76 = { class: "whitespace-nowrap" }
const _hoisted_77 = {
  class: "bg-gray-lp-1300 flex-1 text-gray-lp-1300 relative",
  style: {"height":"1px"}
}
const _hoisted_78 = { class: "w-full text-xs text-center flight-main-text-color" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_LpButton = _resolveComponent("LpButton")!

  return (_openBlock(), _createBlock("div", {
    tabindex: "0",
    role: "button",
    class: ["card-search-flight rounded-xl flight-border-color", {
      selected: false,
      disabled: _ctx.flightDisabled
    }],
    id: _ctx.flight.uniqueId,
    "data-testid": 'cargo-search-flight-card-' + _ctx.flight.uniqueId
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, _toDisplayString(_ctx.formatTime(_ctx.flight.departureDate)), 1),
          _createVNode("div", _hoisted_5, _toDisplayString(_ctx.formatDateShort(_ctx.flight.departureDate)), 1)
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_Icons, {
              name: "plane-departure",
              style: {"width":"14px","height":"14px"}
            }),
            _createVNode("div", _hoisted_8, [
              _createTextVNode(_toDisplayString(_ctx.formatDuration(_ctx.flight.totalTravelTimeMin)) + " • ", 1),
              _createVNode("span", _hoisted_9, _toDisplayString(_ctx.transitLabel), 1)
            ]),
            _createVNode(_component_Icons, {
              name: "plane-arrival",
              style: {"width":"14px","height":"14px"}
            })
          ]),
          _hoisted_10,
          _createVNode("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, _toDisplayString(_ctx.flight.originAirportCode), 1),
            _createVNode("div", _hoisted_13, [
              _createVNode("img", {
                src: _ctx.getFlightIcon(_ctx.firstFlightNo),
                alt: "flight-icon",
                class: ["flight-icon", { 'flight-icon--disabled': _ctx.flightDisabled }],
                style: {"width":"24px","height":"24px"}
              }, null, 10, ["src"]),
              _createVNode("span", _hoisted_14, _toDisplayString(_ctx.firstFlightNo), 1)
            ]),
            _createVNode("div", _hoisted_15, _toDisplayString(_ctx.flight.destinationAirportCode), 1)
          ])
        ]),
        _createVNode("div", _hoisted_16, [
          _createVNode("div", _hoisted_17, [
            _createTextVNode(_toDisplayString(_ctx.formatTime(_ctx.flight.arrivalDate)) + " ", 1),
            (_ctx.arrivalDayDiff > 0)
              ? (_openBlock(), _createBlock("div", _hoisted_18, _toDisplayString(_ctx.$t("cargo.v2.flight.search.card.arrivalDayOffset", {
                  count: _ctx.arrivalDayDiff
                })), 1))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_19, _toDisplayString(_ctx.formatDateShort(_ctx.flight.arrivalDate)), 1)
        ])
      ]),
      _createVNode("div", _hoisted_20, [
        (!_ctx.flight.isVolumeAvailability)
          ? (_openBlock(), _createBlock("div", _hoisted_21, [
              _createVNode(_component_Icons, {
                name: "warning-triangle",
                style: {"width":"16px","height":"16px"}
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("cargo.v2.flight.search.card.volumeUnavailable")), 1)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.flight.dimensionAvailable)
          ? (_openBlock(), _createBlock("div", _hoisted_22, [
              _createVNode(_component_Icons, {
                name: "warning-triangle",
                style: {"width":"16px","height":"16px"}
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("cargo.v2.flight.search.card.dimensionUnavailable")), 1)
            ]))
          : (!_ctx.flight.capacityAvailable)
            ? (_openBlock(), _createBlock("div", _hoisted_23, [
                _createVNode(_component_Icons, {
                  name: "warning-triangle",
                  style: {"width":"16px","height":"16px"}
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("cargo.v2.flight.search.card.capacityUnavailable")), 1)
              ]))
            : (_ctx.flight.embargo)
              ? (_openBlock(), _createBlock("div", _hoisted_24, [
                  _createVNode(_component_Icons, {
                    name: "warning-triangle",
                    style: {"width":"16px","height":"16px"}
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("cargo.v2.flight.search.card.embargo")) + " " + _toDisplayString(_ctx.flight.embargoReason ? `: ${_ctx.flight.embargoReason}` : ""), 1)
                ]))
              : (!_ctx.flight.isDgAllowed)
                ? (_openBlock(), _createBlock("div", _hoisted_25, [
                    _createVNode(_component_Icons, {
                      name: "warning-triangle",
                      style: {"width":"16px","height":"16px"}
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("cargo.v2.flight.search.card.dgNotAllowed")), 1)
                  ]))
                : (_ctx.flight.historyDepartureStatus === 'delayed' && _ctx.useFcsHistoryDepartureBadge)
                  ? (_openBlock(), _createBlock("div", _hoisted_26, [
                      _createVNode(_component_Icons, {
                        name: "clock-warning",
                        style: {"width":"16px","height":"16px"}
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("cargo.v2.flight.search.card.potentialDelay")), 1)
                    ]))
                  : (_ctx.flight.historyDepartureStatus && _ctx.useFcsHistoryDepartureBadge)
                    ? (_openBlock(), _createBlock("div", _hoisted_27, [
                        _createVNode(_component_Icons, {
                          name: "priority-fast",
                          style: {"width":"16px","height":"16px"}
                        }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("cargo.v2.flight.search.card.onTime")), 1)
                      ]))
                    : _createCommentVNode("", true),
        (_ctx.flight.isVolumeAvailability)
          ? (_openBlock(), _createBlock("div", _hoisted_28, [
              _createTextVNode(_toDisplayString(_ctx.$t("cargo.v2.flight.search.card.capacityAvailable")) + " ", 1),
              (!_ctx.flight.capacityAvailable)
                ? (_openBlock(), _createBlock("span", _hoisted_29, _toDisplayString(_ctx.lowestTransitCapacity?.originAirportCode) + " - " + _toDisplayString(_ctx.lowestTransitCapacity?.destinationAirportCode), 1))
                : _createCommentVNode("", true),
              _hoisted_30,
              _createVNode("span", _hoisted_31, _toDisplayString(_ctx.formatCapacity(_ctx.lowestTransitCapacity?.remainingCapacity || 0)) + " " + _toDisplayString(_ctx.$t("cargoV2.components.common.kg")), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode("div", _hoisted_32, [
      _createVNode("div", _hoisted_33, [
        _createVNode(_component_Icons, {
          name: "clock-v3",
          style: {"width":"14px","height":"14px"},
          class: "text-gray-lp-600"
        }),
        _createVNode("span", _hoisted_34, _toDisplayString(_ctx.$t("cargo.v2.flight.search.card.departsIn")), 1),
        _createVNode("span", _hoisted_35, _toDisplayString(_ctx.$t("cargo.v2.flight.search.card.duration", {
              hours: _ctx.departureHours,
              mins: _ctx.departureMinutes
            })), 1)
      ]),
      _createVNode("div", _hoisted_36, [
        (_ctx.flight.itineraries.length > 1)
          ? (_openBlock(), _createBlock("button", {
              key: 0,
              class: "flex items-center gap-x-1 hover:underline flight-main-text-color",
              type: "button",
              "data-testid": "cargo-search-flight-toggle-transit",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleTransit && _ctx.toggleTransit(...args)))
            }, [
              _createVNode("span", _hoisted_37, _toDisplayString(!_ctx.isTransitOpen
                ? _ctx.$t("cargo.v2.flight.search.card.viewTransitDetail")
                : _ctx.$t("cargo.v2.flight.search.card.closeTransit")), 1),
              _createVNode(_component_Icons, {
                name: "chevron-down-new",
                style: [{"width":"20px","height":"20px"}, {
              transform: _ctx.isTransitOpen ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.3s ease-in-out',
            }]
              }, null, 8, ["style"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_LpButton, {
          "data-testid": "cargo-search-flight-button-booking",
          customClass: "w-32 py-2",
          title: _ctx.$t('cargo.v2.flight.search.card.booking'),
          textColor: "white",
          color: "red-lp-2400",
          compact: "",
          disabled: _ctx.flightDisabled || _ctx.isLoadingSubmit,
          onClick: _ctx.handleClickCard
        }, null, 8, ["title", "disabled", "onClick"])
      ])
    ]),
    (_ctx.isTransitOpen && !_ctx.isGridLayout)
      ? (_openBlock(), _createBlock("div", _hoisted_38, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.flight.itineraries, (transit, index) => {
            return (_openBlock(), _createBlock("div", {
              key: _ctx.flight.uniqueId+transit.departureDate,
              class: "flex flex-row items-center gap-1 flex-grow",
              "data-testid": 'cargo-search-flight-transit-segment-' + index
            }, [
              _createVNode("div", {
                class: ["flex flex-col justify-center items-center", { 'px-2': index === 0 }]
              }, [
                (index === 0)
                  ? (_openBlock(), _createBlock("div", _hoisted_39, _toDisplayString(_ctx.$t("cargo.labels.originCity")), 1))
                  : (_openBlock(), _createBlock("div", _hoisted_40, _toDisplayString(_ctx.$t("cargoV2.components.cardFlight.transit", { count: index })), 1)),
                _createVNode("div", _hoisted_41, [
                  (index > 0)
                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_Icons, {
                          name: "plane-arrival",
                          style: {"width":"8px","height":"8px"}
                        }),
                        _createTextVNode(" " + _toDisplayString(_ctx.formatTime(_ctx.flight.itineraries[index-1].arrivalDate || "")) + " ", 1),
                        _hoisted_42
                      ], 64))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.formatTime(transit.departureDate)) + " ", 1),
                  _createVNode(_component_Icons, {
                    name: "plane-departure",
                    style: {"width":"8px","height":"8px"}
                  })
                ]),
                _createVNode("div", _hoisted_43, [
                  (index > 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_44, _toDisplayString(_ctx.formatDateTransit(_ctx.flight.itineraries[index-1].arrivalDate || "")), 1))
                    : _createCommentVNode("", true),
                  _createVNode("div", null, _toDisplayString(_ctx.formatDateTransit(transit.departureDate)), 1)
                ]),
                _createVNode("div", _hoisted_45, _toDisplayString(transit.originAirportCode), 1)
              ], 2),
              _createVNode("div", _hoisted_46, [
                _createVNode("div", _hoisted_47, [
                  _hoisted_48,
                  _createVNode("div", _hoisted_49, [
                    _createVNode("img", {
                      src: _ctx.getFlightIcon(transit.flightNo),
                      alt: "flight-icon",
                      class: { 'flight-icon--disabled': _ctx.flightDisabled },
                      style: {"width":"32px","height":"32px"}
                    }, null, 10, ["src"]),
                    _createVNode("span", _hoisted_50, _toDisplayString(transit.flightNo), 1)
                  ]),
                  _createVNode("div", _hoisted_51, [
                    _createVNode(_component_Icons, {
                      name: "arrow-up",
                      style: {"transform":"rotate(90deg)","position":"absolute","top":"-4.5","right":"-2","width":"10px","height":"10px"}
                    })
                  ])
                ]),
                _createVNode("div", _hoisted_52, _toDisplayString(_ctx.$t("cargo.v2.flight.search.card.transitCapacity", {
                kg: _ctx.formatCapacity(transit.remainingCapacity)
              })), 1)
              ]),
              (index === _ctx.flight.itineraries.length - 1)
                ? (_openBlock(), _createBlock("div", _hoisted_53, [
                    _createVNode("div", _hoisted_54, _toDisplayString(_ctx.$t("cargo.labels.destinationCity")), 1),
                    _createVNode("div", _hoisted_55, [
                      _createVNode(_component_Icons, {
                        name: "plane-arrival",
                        style: {"width":"8px","height":"8px"}
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.formatTime(transit.arrivalDate)), 1)
                    ]),
                    _createVNode("div", _hoisted_56, _toDisplayString(_ctx.formatDateTransit(transit.arrivalDate)), 1),
                    _createVNode("div", _hoisted_57, _toDisplayString(transit.destinationAirportCode), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 8, ["data-testid"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.isTransitOpen && _ctx.isGridLayout)
      ? (_openBlock(), _createBlock("div", _hoisted_58, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.transitGridRows, (row, rowIndex) => {
            return (_openBlock(), _createBlock("div", {
              key: rowIndex,
              class: ["flex flex-row items-center gap-1 p-2", rowIndex % 2 === 0 ? 'bg-gray-lp-2800' : 'bg-white'],
              "data-testid": 'cargo-search-flight-transit-grid-row-' + rowIndex
            }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(row, (item, itemIndex) => {
                return (_openBlock(), _createBlock("div", {
                  key: itemIndex,
                  class: "flex flex-row items-center gap-1 flex-1"
                }, [
                  (item.isEmpty)
                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [], 64))
                    : (item.isDestination)
                      ? (_openBlock(), _createBlock("div", _hoisted_59, [
                          _createVNode("div", _hoisted_60, _toDisplayString(_ctx.$t("cargo.labels.destinationCity")), 1),
                          _createVNode("div", _hoisted_61, [
                            _createVNode(_component_Icons, {
                              name: "plane-arrival",
                              style: {"width":"8px","height":"8px"}
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.formatTime(item.transit.arrivalDate)), 1)
                          ]),
                          _createVNode("div", _hoisted_62, _toDisplayString(_ctx.formatDateTransit(item.transit.arrivalDate)), 1),
                          _createVNode("div", _hoisted_63, _toDisplayString(item.transit.destinationAirportCode), 1)
                        ]))
                      : (!item.isEmpty)
                        ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                            _createVNode("div", _hoisted_64, [
                              (item.index === 0)
                                ? (_openBlock(), _createBlock("div", _hoisted_65, _toDisplayString(_ctx.$t("cargo.labels.originCity")), 1))
                                : (_openBlock(), _createBlock("div", _hoisted_66, _toDisplayString(_ctx.$t("cargoV2.components.cardFlight.transit", { count: item.index })), 1)),
                              _createVNode("div", _hoisted_67, [
                                (item.index > 0)
                                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                      _createVNode(_component_Icons, {
                                        name: "plane-arrival",
                                        style: {"width":"8px","height":"8px"}
                                      }),
                                      _createTextVNode(" " + _toDisplayString(_ctx.formatTime(_ctx.flight.itineraries[item.index - 1].arrivalDate || "")) + " ", 1),
                                      _hoisted_68
                                    ], 64))
                                  : _createCommentVNode("", true),
                                _createTextVNode(" " + _toDisplayString(_ctx.formatTime(item.transit.departureDate)) + " ", 1),
                                _createVNode(_component_Icons, {
                                  name: "plane-departure",
                                  style: {"width":"8px","height":"8px"}
                                })
                              ]),
                              _createVNode("div", _hoisted_69, [
                                (item.index > 0)
                                  ? (_openBlock(), _createBlock("div", _hoisted_70, _toDisplayString(_ctx.formatDateTransit(_ctx.flight.itineraries[item.index - 1].arrivalDate || "")), 1))
                                  : _createCommentVNode("", true),
                                _createVNode("div", null, _toDisplayString(_ctx.formatDateTransit(item.transit.departureDate)), 1)
                              ]),
                              _createVNode("div", _hoisted_71, _toDisplayString(item.transit.originAirportCode), 1)
                            ]),
                            _createVNode("div", _hoisted_72, [
                              _createVNode("div", _hoisted_73, [
                                _hoisted_74,
                                _createVNode("div", _hoisted_75, [
                                  _createVNode("img", {
                                    src: _ctx.getFlightIcon(item.transit.flightNo),
                                    alt: "flight-icon",
                                    class: { 'flight-icon--disabled': _ctx.flightDisabled },
                                    style: {"width":"32px","height":"32px"}
                                  }, null, 10, ["src"]),
                                  _createVNode("span", _hoisted_76, _toDisplayString(item.transit.flightNo), 1)
                                ]),
                                _createVNode("div", _hoisted_77, [
                                  _createVNode(_component_Icons, {
                                    name: "arrow-up",
                                    style: {"transform":"rotate(90deg)","position":"absolute","top":"-4.5","right":"-2","width":"10px","height":"10px"}
                                  })
                                ])
                              ]),
                              _createVNode("div", _hoisted_78, _toDisplayString(_ctx.$t("cargo.v2.flight.search.card.transitCapacity", {
                    kg: _ctx.formatCapacity(item.transit.remainingCapacity)
                  })), 1)
                            ])
                          ], 64))
                        : _createCommentVNode("", true)
                ]))
              }), 128))
            ], 10, ["data-testid"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 10, ["id", "data-testid"]))
})